import { useQueryClient } from '@tanstack/react-query';
import { getFindProductGridRootKey } from '../../../services/modules/product-grid/product-grid.keys';
import { getOrderProductUniqueIdentifier } from '../../../utils/getOrderProductUniqueIdentifier';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { useRachelListTransition } from '../../rachel/hooks/useRachelListTransition';
import { notifyAppliedProductsAdded } from '../products/add-product/hooks/useProductAddedNotification';
import { OrderProduct } from '../products/orderProducts.types';

export const useOrderProductsRachelTransition = (products: OrderProduct[]) => {
  const queryClient = useQueryClient();
  const { team } = useApplicationContext();

  return useRachelListTransition({
    items: products,
    getKey: getOrderProductUniqueIdentifier,
    onApplied: () =>
      queryClient.refetchQueries({
        queryKey: [team?.id, ...getFindProductGridRootKey()],
        type: 'active',
      }),
    onAdded: notifyAppliedProductsAdded,
  });
};
